import React from 'react'
import ReactDOMServer from 'react-dom/server'
import {
    getImage, getLocationName,
} from '../../sportvenues/helpers'
import { LinkOrDiv } from '../../events/helpers'
import { wrapperHighlightPin } from '../../../../components/shared/toggle-highlight-pin'
import Configurator from '../../../../configurator'
import { i18n } from '../../../../validator'
import { ImageResized } from '../../../../components/shared/webp-image-resized'

const DefaultSportIcon = '/images/default-sport.png'
const DefaultHeaderImage = '/images/default-detail-logo_2.jpg'

@i18n()
class Box extends Configurator {

    state = { showError: false }

    render() {
        const {
            sportVenue,
            mainClassName,
            t,
        } = this.props

        const {
            REACT_APP_TRANSLATION_ROUTES: routes,
            REACT_APP_SPORT_VENUE_DETAIL: showDetail,
        } = this.config

        const hashtags = sportVenue?.filteredHashtags

        return (
            <LinkOrDiv
                className={`${mainClassName}__group-box`}
                onClick={() => this.scrollTop()}
                href={showDetail ? `/${routes.sportVenues}/${sportVenue.slug}` : null}
                reactLink={true}
            >
                <div className={`${mainClassName}__group-box-content`}>
                    <div className={`${mainClassName}__group-box-content__header-image`}>
                        <ImageResized
                            src={sportVenue?.headerImage?.data?.path}
                            defaultSrc={DefaultHeaderImage}
                            size="cover-sm"
                            alt={t('sportVenuesLogo')}
                        />
                    </div>
                    <div className={`${mainClassName}__group-box-content-logos`}>
                        <div className={`${mainClassName}__group-box-content-logos-element h-100`}>
                            <ImageResized
                                src={sportVenue?.logo?.data?.path}
                                defaultSrc={DefaultSportIcon}
                                size="logo"
                                alt=""
                            />
                        </div>
                        <div className={`${mainClassName}__group-box-content__name ellipsis-clamp-2`}>
                            {sportVenue.name}
                        </div>
                    </div>
                    <div className={`${mainClassName}__group-box-content-match`}>
                        <div className={`${mainClassName}__group-box-content-match-sport font-weight-bold`}>
                            {!sportVenue.sports ? '' :
                                (sportVenue.sports.data.length > 2 ? t('moreSports') : sportVenue.sports.data[0].name)
                            }
                        </div>
                        {(hashtags && hashtags.length > 0) &&
                            <div className="d-flex flex-row align-items-center">
                                <div className="font-weight-bold mr-2 text-color-gray-dark-1">
                                    {t('state')}:
                                </div>
                                <div
                                    className="text-color-gray-dark-1 font-weight-normal"
                                    dangerouslySetInnerHTML={{
                                        __html: hashtags
                                            .map(hashtag => ReactDOMServer.renderToStaticMarkup(<span key={hashtag.key} className="text-capitalize">{hashtag.name}</span>))
                                            .join(', '),
                                    }}
                                />
                            </div>
                        }
                        <div className={`${mainClassName}__group-box-content-match-address`} title={getLocationName(sportVenue, true)}>
                            <div className={`${mainClassName}__group-box-content-match-address-in`}>{getLocationName(sportVenue)}</div>
                        </div>
                    </div>
                </div>
            </LinkOrDiv>
        )
    }
}

export default wrapperHighlightPin(Box, 'sportVenue')
